const c = {
  name: "DigitalSignature",
  dimensions: { width: 40, height: 21 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 21" style="enable-background:new 0 0 40 21;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36.5,10.9L36.5,10.9L26.4,21H19c-1.6,0-3-0.7-4.1-1.9c-1.3-1.6-3.3-2.5-5.4-2.5c-2.1,0-4.1,0.9-5.4,2.5
			C3,20.3,1.6,21,0,21v-2c1,0,1.9-0.4,2.5-1.2c1.7-2.1,4.3-3.3,7-3.3c2.7,0,5.2,1.2,7,3.3C17.1,18.6,18,19,19,19v-5.4L31.1,1.5
			c0.1-0.1,0.2-0.2,0.4-0.3C32.3,0.4,33.5,0,34.8,0s2.4,0.4,3.4,1.2c0.1,0.1,0.2,0.2,0.3,0.3c1,1,1.5,2.3,1.5,3.7
			c0,1.2-0.4,2.5-1.3,3.4c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.1L36.5,10.9z M37,7.5C37.1,7.5,37.1,7.5,37,7.5
			c0.1-0.1,0.1-0.2,0.2-0.2C37.7,6.8,38,6,38,5.3c0-0.9-0.3-1.7-1-2.3c-0.1-0.1-0.1-0.1-0.2-0.1c-1.2-1-3-1-4.2,0
			c-0.1,0.1-0.1,0.1-0.2,0.2l-0.5,0.5l4.6,4.6L37,7.5z M21,14.4V19h4.6l9.5-9.5l-4.6-4.6L21,14.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as DigitalSignature
};
